<template>
  <main>
    <app-form @submit.prevent="advanceStep">

      <marketing-email-form-models @selected="setInitialModel" />

    </app-form>
  </main>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import MarketingEmailFormModels from "@components/modules/marketing/email/form/models/MarketingEmailFormModels";

export default {
  components: {
    AppForm,
    MarketingEmailFormModels,
  },

  props: {},

  computed: {},

  watch: {},

  data() {
    return {};
  },

  methods: {
    setInitialModel(model) {
      this.addInfoToEmailDataInSessionStorage(model);
      this.$store.commit("EMAIL_CREATE_SET_MODEL", model);

      this.advanceStep();
    },
    addInfoToEmailDataInSessionStorage(model) {
      const emailForm = JSON.parse(sessionStorage.getItem("email_data"));
      emailForm.model = model
      
      sessionStorage.setItem("email_data", JSON.stringify(emailForm))
    },    
    async advanceStep() {
      this.$store.commit("SET_EMAIL_CREATE_STEP", 2);
      sessionStorage.setItem("email_step", 2);
     
      this.$router.push({
        path: "/marketing/email/criar/conteudo",
      });
    },
  },  
};
</script>

<style lang="scss" scoped>
</style>

